import { render, staticRenderFns } from "./FaqNavbar.vue?vue&type=template&id=03cba755"
import script from "./FaqNavbar.vue?vue&type=script&lang=js"
export * from "./FaqNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports